// Todo:
// 1) Make the button prettier
// 2) add a config option for IE users which takes a URL.  That URL should accept a POST request with a
//    JSON encoded object in the payload and return a CSV.  This is necessary because IE doesn't let you
//    download from a data-uri link
//
// Notes:  This has not been adequately tested and is very much a proof of concept at this point
function ngGridCsvExportPlugin(opts) {
    var self = this;
    self.grid = null;
    self.scope = null;
    self.services = null;

    opts = opts || {};
    opts.dropdownTemplate = opts.dropdownTemplate || '';
    opts.containerPanel = opts.containerPanel || '.ngFooterPanel';
    opts.linkClass = opts.linkCss || 'csv-data-link-span';
    opts.linkLabel = opts.linkLabel || 'CSV Export';
    opts.fileName = opts.fileName || 'Export.csv';
    opts.isExportDisabled = opts.isExportDisabled || true;
     
    self.init = function (scope, grid, services) {
        self.grid = grid;
        self.scope = scope;
        self.services = services;
        scope.isExportDisabled = opts.isExportDisabled;

        function showDs() {
            /// <summary>
            /// Shows the ds.
            /// </summary>
            /// <returns></returns>
            function csvStringify(str) {
                if (str == null) { // we want to catch anything null-ish, hence just == not ===
                    return '';
                }
                if (typeof (str) === 'number') {
                    return '' + str;
                }
                if (typeof (str) === 'boolean') {
                    return (str ? 'TRUE' : 'FALSE');
                }
                if (typeof (str) === 'string') {
                    return str.replace(/"/g, '""');
                }

                return JSON.stringify(str).replace(/"/g, '""');
            }

            var keys = [];
            var csvData = '';
            for (var f in grid.config.columnDefs) {
                if (grid.config.columnDefs.hasOwnProperty(f)) {
                    keys.push(grid.config.columnDefs[f].field);
                    csvData += '"';
                    if (typeof grid.config.columnDefs[f].displayName !== 'undefined') {/** moved to reduce looping and capture the display name if it exists**/
                        csvData += csvStringify(grid.config.columnDefs[f].displayName);
                    }
                    else {
                        csvData += csvStringify(grid.config.columnDefs[f].field);
                    }
                    csvData += '",';
                }
            }

            function swapLastCommaForNewline(str) {
                var newStr = str.substr(0, str.length - 1);
                return newStr + "\n";
            }

            csvData = swapLastCommaForNewline(csvData);
            var gridData = grid.data;
            for (var gridRow in gridData) {
                var rowData = '';
                for (var k in keys) {
                    var curCellRaw;

                    if (opts != null && opts.columnOverrides != null && opts.columnOverrides[keys[k]] != null) {
                        curCellRaw = opts.columnOverrides[keys[k]](
                            self.services.UtilityService.evalProperty(gridData[gridRow], keys[k]));
                    } else {
                        curCellRaw = self.services.UtilityService.evalProperty(gridData[gridRow], keys[k]);
                    }

                    rowData += '"' + csvStringify(curCellRaw) + '",';
                }
                csvData += swapLastCommaForNewline(rowData);
            }
            
            var fp = grid.$root.find(opts.containerPanel);
            var csvDataLinkPrevious = grid.$root.find(opts.containerPanel + ' .' + opts.linkClass);
            if (csvDataLinkPrevious != null) { csvDataLinkPrevious.remove(); }
            var csvDataLinkHtml = '<div class="' + opts.linkClass + ' text-center" >';
            csvDataLinkHtml += '<div class="btn-group btn-group-justified">';
            csvDataLinkHtml += '<a type="button" ng-click="requestCurrentPosition()" ng-if="isAssetSelected && permissionSet.requestCurrentPosition && !isAtg" class="btn btn-default btn-footer-grid" href=""><span translate="RequestCurrentPosition"';
            csvDataLinkHtml += '>Request Current Position</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="requestFuelLevel()" ng-if="isAssetSelected && permissionSet.requestCurrentPosition && isAtg" class="btn btn-default btn-footer-grid" href=""><span translate="RequestFuelLevel"';
            csvDataLinkHtml += '>Request Fuel Level</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="showSendMessage(assetSelected);" ng-if="!isCanis && permissionSet.isMdt && assetSelected.hardwareMdt" class="btn btn-default btn-footer-grid" href=""><span translate="SendMessage"';
            csvDataLinkHtml += '>Send Message</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="immobilizeAsset()" ng-if="isAssetSelected && assetSelected.hardwareImmobilizer" class="btn btn-default btn-footer-grid" href=""><span translate="ImmobilizerController"';
            csvDataLinkHtml += '>Immobilizer Controller</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addGeofence()" ng-if="!isCanis && isAssetSelected" class="btn btn-default btn-footer-grid" href=""><span translate="AddGeofences" ';
            csvDataLinkHtml += '>Add Geofences</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addSpeedZone()" ng-if="!isCanis && isAssetSelected" class="btn btn-default btn-footer-grid " href=""><span translate="AddSpeedZones"';
            csvDataLinkHtml += '>Add Speed Zones</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addTimezone()" ng-if="!isCanis && isAssetSelected" class="btn btn-default btn-footer-grid "   href=""><span translate="AddTimezones"';
            csvDataLinkHtml += '>Add Timezones</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addAreas()" ng-if="(isAccountSelected || isAssetSelected) && userData.permissionsSet.editAreasWaypointsRoutes" class="btn btn-default btn-footer-grid" "href=""><span translate="AddAreas"';
            csvDataLinkHtml += '>Add Areas</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addRoute()" ng-if="(isAccountSelected || isAssetSelected) && userData.permissionsSet.editAreasWaypointsRoutes" class="btn btn-default btn-footer-grid"  href=""><span translate="AddRoutes" ';
            csvDataLinkHtml += '>Add Routes</span></a>';
            csvDataLinkHtml += '<a type="button" ng-click="addWaypoint()" ng-if="(isAccountSelected || isAssetSelected) && userData.permissionsSet.editAreasWaypointsRoutes" class="btn btn-default btn-footer-grid" href=""><span translate="AddWaypoints" ';
            csvDataLinkHtml += '>Add Waypoints</span></a>';
            csvDataLinkHtml += '</div>';
            csvDataLinkHtml += '<div class="text-right export-csv">';
            csvDataLinkHtml += '<a type="button" ng-click="exportToExcel()" ng-hide="' + scope.isExportDisabled + '" class="btn btn-default btn-default btn-footer-grid" href="';
            csvDataLinkHtml += '">' + opts.linkLabel + '</a>';
            csvDataLinkHtml += '<a type="button" ng-click="exportProcessedWarningsToExcel()" ng-show="\'' + opts.fileName + '\'==\'Warning\'" class="btn btn-default btn-default btn-footer-grid" href="';
            csvDataLinkHtml += '">' + '<span translate="ExportProcessedWarnings"></span>' + '</a>';
            csvDataLinkHtml += opts.dropdownTemplate;
            csvDataLinkHtml += '</div>';
            csvDataLinkHtml += '</div>';

            fp.append(scope.$compile(csvDataLinkHtml)(scope));
            //scope.$apply();
        }
        setTimeout(showDs, 0);
        scope.catHashKeys = function () {
            var hash = '';
            for (var idx in scope.renderedRows) {
                hash += scope.renderedRows[idx].$$hashKey;
            }
            return hash;
        };
        if (opts && opts.customDataWatcher) {
            scope.$watch(opts.customDataWatcher, showDs);
        } else {
            scope.$watch(scope.catHashKeys, showDs);
        }
    };
}
